window.theme = window.theme || {};


theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.originalEvent.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

theme.SlideShows = (function() {
   
  function SlideShows(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.slideShowId = $("#shopify-section-"+sectionId) ;
    this.countdownHolder = $(".count_holder_small-"+sectionId);
    this.slideShowNamspace = "#home-slideshow-"+sectionId;
    this.slideShow = $("#home-slider-"+sectionId);
    this.slideShowTxt =  "#home-slider-"+sectionId;
    this.slideShowCamera = $("#home-camera-slider-"+sectionId);
    this.slideShowOverlay = $("#home-slider-overlay-"+sectionId);
    this.showSlideshow = $("#home-slider-"+sectionId).data('show_slideshow');
    this.slideshowAuto = $("#home-slider-"+sectionId).data('slideshow_auto');
    this.slideshowInterval = $("#home-slider-"+sectionId).data('slideshow_interval');
    this.SlideshowDots = $("#home-slider-"+sectionId).data('show_slideshow_dots');
    this.SlideshowDotsColour = $("#home-slider-"+sectionId).data('slideshow_dots_colour');
    this.optionsCamera = {
      loader: "none",
      autoAdvance: this.slideshowAuto,
      mobileAutoAdvance: this.slideshowAuto,
      pagination: this.SlideshowDots,
      time: this.slideshowInterval,
      thumbnails: !1,
      playPause: !1
    };
    this.optionsResponsive = {
      autoplay: this.slideshowAuto,
      interval: this.slideshowInterval,
      transitionTime: 300
    }
    this._slide();
    this._countdown();
    this._pulsate();
  }

  SlideShows.prototype = _.assignIn({}, SlideShows.prototype, {
    _scroll: function(){
      $('html,body').animate({scrollTop: this.slideShowId.offset().top - 50}, 'slow');
    },
    _countdown: function() {
      var currentDay = new Date();
      !$('html').hasClass('ie8') &&( this.countdownHolder.length && (
        this.countdownHolder.each(function(){
          var offerDay = $(this).data('slide_expires').split('-');
          var offerDay = new Date( offerDay[2], (parseInt(offerDay[0]) - 1), offerDay[1] );
          if(currentDay < offerDay){
            $(this).children().countdown({until: offerDay});
          }else{
            $(this).hide();
          }
        })
      ))
    },
    _pulsate: function() {
      jQuery().pulsate && (navigator.userAgent.match(/MSIE 8.0/) || jQuery().pulsate && (this.slideShow.on("mouseup", ".slider-control", function(a) {
            1 === a.which && $(this.slideShowTxt + " .slider-control .btn-label").pulsate({
                repeat: !1,
                reach: 10
            })
        }), this.slideShow.on("mouseup", ".pages .page", function(a) {
            $(this).hasClass("active") || 1 !== a.which || $(this).pulsate({
                color: this.SlideshowDotsColour,
                repeat: !1,
                reach: 10
            })
        }), this.slideShow.on("mouseup", ".camera_pag li", function(a) {
            $(this).hasClass("cameracurrent") || 1 !== a.which || $(this).pulsate({
                color: this.SlideshowDotsColour,
                repeat: !1,
                reach: 10
            })
        })))
    },
    _mockupResponsiveSlider: function() {
        var a = new Array;
        a[0] = "slideAppearRightToLeft", a[1] = "slideAppearLeftToRight", a[2] = "slideAppearUpToDown", a[3] = "slideAppearDownToUp", $(this.slideShowTxt+" [data-animate]").each(function() {
            var b = roar.getRandomInt(0, 3),
                c = a[b];
            $(this).attr("data-animate", c)
        })
    },
    _mockupCameraSlideshow: function() {
        var a = new Array;
        a[0] = "moveFromLeft", a[1] = "moveFomRight", a[2] = "fadeIn", a[3] = "fadeFromLeft", a[4] = "fadeFromRight", $(this.slideShowTxt+" .camera_caption").each(function() {
            var b = roar.getRandomInt(0, 4),
                c = a[b];
            $(this).removeClass("fadeIn").addClass(c)
        })
    },
    _slide: function() {
      var slideShowOverlay = this.slideShowOverlay;
      "camera" == this.showSlideshow && this.slideShowCamera.cameraStop();
      this.slideShow.length && (("camera" == this.showSlideshow)? this.slideShowCamera.camera(this.optionsCamera) : "responsive" == this.showSlideshow && (this._mockupResponsiveSlider(), this.slideShow.responsiveSlider(this.optionsResponsive), imagesLoaded(this.slideShowTxt, function() {
            slideShowOverlay.hide()
        })))
    },
    onUnload: function(evt) {
	  this.$container.off(this.slideShowNamspace);
    },
    onSelect: function(evt) {
     "responsive" == this.showSlideshow && (this._slide());
      this._countdown();
      this._pulsate();
      this._scroll();
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });
  return SlideShows;
})();

theme.SpecialOffers = (function() {
   
	
  function SpecialOffers(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.specialOffer = $("#special-offers-"+sectionId);
    this.specialOfferNamspace = "#special-offers-"+sectionId;
    this.specialOfferId = $("#shopify-section-"+sectionId) ;
    var options = this.options = {
      navigation: !0,
      pagination: !1,
      mouseDrag: !1,
      items: 3,
      itemsDesktop: [1199, 3],
      itemsDesktopSmall: [979, 3],
      itemsTablet: [768, 3],
      itemsTabletSmall: [767, 2],
      itemsMobile: [479, 1],
      scrollPerPage: !0,
      navigationText: ['<span class="btn btn-1 mini"><i class="icon-angle-left"></i></span>', '<span class="btn btn-1 mini"><i class="icon-angle-right"></i></span>']
    };
    this._slide();
  }

  SpecialOffers.prototype = _.assignIn({}, SpecialOffers.prototype, {
    _scroll: function(){
      $('html,body').animate({scrollTop: this.specialOfferId.offset().top - 50}, 'slow');
    },
    _slide: function() {
    	this.specialOffer.owlCarousel(this.options);
    },
    onUnload: function(evt) {
	  this.$container.off(this.specialOfferNamspace);
    },
    onSelect: function(evt) {
     // this._slide();
      this._scroll();
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });
  return SpecialOffers;
})();


theme.FeaturedCollections = (function() {

  function FeaturedCollections(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.featuredCollection = $("#featured-collections-"+sectionId);
    this.featuredCollectionNamespace = "#featured-collections-"+sectionId;
    this.featuredCollectionId =  $("#shopify-section-"+sectionId ) ;
    this.featured_collections_home_style = this.featuredCollection.data('featured_collections_home_style');
    this.featured_collections_home_scroll = this.featuredCollection.data('featured_collections_home_scroll');
    this._styleHome();
  }

  FeaturedCollections.prototype = _.assignIn({}, FeaturedCollections.prototype, {
    _styleHome: function() {
       this.featuredCollection.length && ("scroll" == this.featured_collections_home_style ? this.featuredCollection.mCustomScrollbar({
          horizontalScroll: !0,
          scrollInertia: 100
       }) : "carousel" ==this.featured_collections_home_style && this.featuredCollection.owlCarousel({
          navigation: !0,
          pagination: !1,
          mouseDrag: !1,
          items: 4,
          itemsDesktop: [1199, 4],
          itemsDesktopSmall: [979, 3],
          itemsTablet: [768, 2],
          itemsTabletSmall: [767, 2],
          itemsMobile: [479, 1],
          scrollPerPage: this.featured_collections_home_scroll,
          navigationText: ['<span class="btn btn-1 mini"><i class="icon-angle-left"></i></span>', '<span class="btn btn-1 mini"><i class="icon-angle-right"></i></span>']
       }))
    },
    _scroll: function(){
      $('html,body').animate({scrollTop: this.featuredCollectionId.offset().top - 50}, 'slow');
    },
    onUnload: function(evt) {
      this.$container.off(this.featuredCollectionNamespace);
    },
    onSelect: function(evt) {
      // this._styleHome();
      this._scroll();
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });

  return FeaturedCollections;
})();


theme.FeaturedProducts = (function() {

  function FeaturedProducts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.featuredProduct = $("#featured-products-"+sectionId);
    this.featuredProduct = $("#featured-products-"+sectionId);
    this.featuredProductNamespace = "#featured-products-"+sectionId;
    this.featuredProductId =  $("#shopify-section-"+sectionId ) ;
    this.featured_products_home_style = this.featuredProduct.data('featured_products_home_style');
    this.featured_products_home_scroll = this.featuredProduct.data('featured_products_home_scroll');
    this._styleHome();
    
  }

  FeaturedProducts.prototype = _.assignIn({}, FeaturedProducts.prototype, {
    _styleHome: function() {
      this._styleSection();
      this._fancy();
    },
    _scroll: function(){
      $('html,body').animate({scrollTop: this.featuredProductId.offset().top - 50}, 'slow');
    },
    _styleSection: function() {
    	this.featuredProduct.length && ("scroll" == this.featured_products_home_style ? this.featuredProduct.mCustomScrollbar({
            horizontalScroll: !0,
            scrollInertia: 100
        }) : "carousel" == this.featured_products_home_style && this.featuredProduct.owlCarousel({
            navigation: !0,
            pagination: !1,
            mouseDrag: !1,
            items: 4,
            itemsDesktop: [1199, 4],
            itemsDesktopSmall: [979, 3],
            itemsTablet: [768, 2],
            itemsTabletSmall: [767, 2],
            itemsMobile: [479, 1],
            scrollPerPage: this.featured_products_home_scroll,
            navigationText: ['<span class="btn btn-1 mini"><i class="icon-angle-left"></i></span>', '<span class="btn btn-1 mini"><i class="icon-angle-right"></i></span>']
        }))
    },
    _fancy: function(){
      	$(this.featuredProductNamespace + " .product-fancybox-buttons").fancybox({
            closeBtn: !1,
            helpers: {
                buttons: {}
            }
        })
    	
    },
    onUnload: function(evt) {
      this.$container.off(this.featuredProductNamespace);
    },
    onSelect: function(evt) {
     //this._styleHome();
      this._scroll();
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });

  return FeaturedProducts;
})();

theme.Oneproduct = (function() {
  
  function Oneproduct(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    
    this.selectors = {
      gallery_main_id: "#gallery_main-"+sectionId,
      gallery_main: "gallery_main-"+sectionId,
      main_image: "#product-image-"+sectionId+" .main-image",
      image_thumb: "#product-image-"+sectionId+" .image-thumb",
      fancybox: "#product-image-"+sectionId+" .section_fancybox",
      product_image: "#product-image-"+sectionId,
      product_image_wrapper: ".product-image-wrapper",
      main_image_bg: ".product-image-"+sectionId+" .main-image .main-image-bg",
      elevatezoom: "#product-image-"+sectionId + " .elevatezoom",
      img_zoom: "#product-image-"+sectionId +" .elevatezoom .img-zoom",
      img_thumb: "#product-image-"+sectionId + " .image-thumb",
    };
    this._handleImageThumbs();
    this._alwaysRefreshZoom();
  }

  Oneproduct.prototype = _.assignIn({}, Oneproduct.prototype, {
    _pulsate: function() {
      jQuery('.pulsate-regular').pulsate({
        reach: 20,
        speed: 1000,
        pause: 1000
      });
    },
    _alwaysRefreshZoom: function() {
      	var img_zoom = this.selectors.img_zoom;
       	var elevatezoom = this.selectors.elevatezoom;
      	var gallery_main = this.selectors.gallery_main;
        if (0 == roar.touch && ("zoom" == window.main_image_display || "both" == window.main_image_display) 
            && $(elevatezoom).length) {
            var a = $(img_zoom);
            a.elevateZoom({
                gallery: gallery_main,
                galleryActiveClass: "active",
                zoomType: "inner",
                cursor: "pointer",
                zoomWindowFadeIn: 300,
                zoomWindowFadeOut: 300,
                scrollZoom: !0,
                easing: !0,
                loadingIcon: window.loader_gif
            }), "both" == window.main_image_display && $(img_zoom).bind("click", function(a) {
                var b = $(img_zoom).data("elevateZoom");
                return $.fancybox(b.getGalleryList(), {
                    closeBtn: !1,
                    helpers: {
                        buttons: {}
                    }
                }), !1
            })
        }
    },
    _handleImageThumbs: function() {
      var img_thumb = this.selectors.img_thumb;
      $(this.selectors.gallery_main_id).length && (roar.touch ? $(this.selectors.main_image).on("click", function() {
            var a = [],
                b = 0,
                c = $(img_thumb);
            return c.each(function(c, d) {
                a.push({
                    href: d.href,
                    title: d.title
                }), $(this).hasClass("active") && (b = c)
            }), $.fancybox(a, {
                closeBtn: !1,
                index: b,
                openEffect: "none",
                closeEffect: "none",
                nextEffect: "none",
                prevEffect: "none",
                helpers: {
                    buttons: {}
                }
            }), !1
        }) : "lightbox" == window.main_image_display && $(this.selectors.fancybox).on(roar.clickEv, function() {
            var a = [],
                b = 0,
                c = $(img_thumb);
            return c.each(function(c, d) {
                a.push({
                    href: d.href,
                    title: d.title
                }), $(this).hasClass("active") && (b = c)
            }), $.fancybox(a, {
                closeBtn: !1,
                index: b,
                helpers: {
                    buttons: {}
                }
            }), !1
        }), $("#product-image-"+ this.sectionId).on("click", ".image-thumb", function() {
            var a = $(this);
            if (!a.hasClass("active")) {
                var b = $(".product-image-"+this.sectionId+" .main-image .main-image-bg"),
                    c = a.parents(".product-image-wrapper"),
                    d = a.attr("data-image-zoom"),
                    e = a.attr("data-image");
                b.show(), c.find(".image-thumb").removeClass("active"), a.addClass("active"), c.find(".main-image").find("img").attr("data-zoom-image", d), c.find(".main-image").find("img").attr("src", e).load(function() {
                    b.hide()
                })
            }
            return !1
        }))
    },
    onUnload: function(evt) {
      this.$container.off(this.Oneproductnamespace);
    },
    onSelect : function(evt) {
    },
    onBlockSelect: function(evt) {
      
    },
    onBlockDeselect: function(evt) {
      
    }
  });

  return Oneproduct;
})();

theme.SpecialProducts = (function() {
   
	
  function SpecialProducts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.SpecialProduct = $("#special-products-"+sectionId);
    this.SpecialProductNamspace = "#special-products-"+sectionId;
    this.SpecialProductId = $("#shopify-section-"+sectionId) ;
    this._effect();
    
  }

  SpecialProducts.prototype = _.assignIn({}, SpecialProducts.prototype, {
    _scroll: function(){
      $('html,body').animate({scrollTop: this.specialOfferId.offset().top - 50}, 'slow');
    },
    _handleScreenshotPreview: function() {
        var a = 100,
            b = 50;
        $(".screenshot").hover(function(c) {
            $("body").append("<p id='screenshot'><span></span><img src='" + $(this).attr("data-rel") + "' alt='' /></p>"), $(this).hasClass("odd") ? $("#screenshot").css("top", c.pageY - a + "px").css("right", c.pageX + b + "px").fadeIn("fast") : $(this).hasClass("even") && $("#screenshot").css("top", c.pageY - a + "px").css("left", c.pageX + b + "px").fadeIn("fast")
        }, function() {
            $("#screenshot").remove()
        }), $(".screenshot").mousemove(function(c) {
            $(this).hasClass("odd") ? $("#screenshot").css("top", c.pageY - a + "px").css("right", c.pageX + b + "px") : $(this).hasClass("even") && $("#screenshot").css("top", c.pageY - a + "px").css("left", c.pageX + b + "px")
        })
    },
    _fancy: function(){
      	$(this.SpecialProductNamspace + " .product-fancybox-buttons").fancybox({
            closeBtn: !1,
            helpers: {
                buttons: {}
            }
        })
    	
    },
    _effect: function(){
    	this._handleScreenshotPreview();
      	this._fancy();
    },
    onUnload: function(evt) {
	  this.$container.off(this.specialOfferNamspace);
    },
    onSelect: function(evt) {
      this._effect();
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });
  return SpecialProducts;
})();


theme.Sidebars = (function() {

  function Sidebars(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = this.sectionType = $container.attr('data-section-type');
    this.sidebarNamespace = "#sidebar-"+sectionId;
    this.sidebarId =  $("#shopify-section-"+sectionId ) ;
    this._sidebar();
  }

  Sidebars.prototype = _.assignIn({}, Sidebars.prototype, {
    _sidebar: function() {
      this._featuredProducts();
      this._featuredCollections();
      this._featuredProduct();
    },
    _fancy: function(){
      	$(this.sidebarNamespace + " .product-fancybox-buttons").fancybox({
            closeBtn: !1,
            helpers: {
                buttons: {}
            }
        })
    	
    },
    _featuredProducts: function() {
      this._fancy();
      $(this.sidebarNamespace + " .featured-products-content").each(function() {
        $(this).length && ("scroll" == $(this).data('featured_item_style') ? $(this).mCustomScrollbar({
            horizontalScroll: !0,
            scrollInertia: 100
          }) : "carousel" == $(this).data('featured_item_style') &&  $(this).owlCarousel({
              navigation: !0,
              pagination: !1,
              mouseDrag: !1,
              items: 3,
              itemsDesktop: [1199, 3],
              itemsDesktopSmall: [979, 2],
              itemsTablet: [768, 2],
              itemsTabletSmall: [767, 2],
              itemsMobile: [479, 1],
              scrollPerPage: $(this).data('featured_item_scroll'),
              navigationText: ['<span class="btn btn-1 mini"><i class="icon-angle-left"></i></span>', '<span class="btn btn-1 mini"><i class="icon-angle-right"></i></span>']
          }))
      });
       
    },
    _featuredCollections: function() {
       $(this.sidebarNamespace + " .featured-collections-content").each(function() {
         $(this).length && ("scroll" == $(this).data('featured_item_style') ? $(this).mCustomScrollbar({
            horizontalScroll: !0,
            scrollInertia: 100
         }) : "carousel" ==$(this).data('featured_item_style') && $(this).owlCarousel({
            navigation: !0,
            pagination: !1,
            mouseDrag: !1,
            items: 3,
            itemsDesktop: [1199, 3],
            itemsDesktopSmall: [979, 2],
            itemsTablet: [768, 2],
            itemsTabletSmall: [767, 2],
            itemsMobile: [479, 1],
            scrollPerPage: $(this).data('featured_item_scroll'),
            navigationText: ['<span class="btn btn-1 mini"><i class="icon-angle-left"></i></span>', '<span class="btn btn-1 mini"><i class="icon-angle-right"></i></span>']
        })) 
       });
    },
    _featuredProduct: function() {
      $(this.sidebarNamespace + ' .sidebar_oneproduct').each(function() {
          var blockId = $(this).data('block-id');
          var featureProductOptions = {
            gallery_main_id: "#gallery_main-"+blockId,
            gallery_main: "gallery_main-"+blockId,
            main_image: "#product-image-"+blockId+" .main-image",
            image_thumb: "#product-image-"+blockId+" .image-thumb",
            fancybox: "#product-image-"+blockId+" .section_fancybox",
            product_image: "#product-image-"+blockId,
            product_image_wrapper: ".product-image-wrapper",
            main_image_bg: ".product-image-"+blockId+" .main-image .main-image-bg",
            elevatezoom: "#product-image-"+blockId + " .elevatezoom",
            img_zoom: "#product-image-"+blockId +" .elevatezoom .img-zoom",
            img_thumb: "#product-image-"+blockId + " .image-thumb"
          };
          var img_zoom = featureProductOptions.img_zoom;
          var elevatezoom = featureProductOptions.elevatezoom;
          var gallery_main = featureProductOptions.gallery_main;
          if (0 == roar.touch && ("zoom" == window.main_image_display || "both" == window.main_image_display) 
              && $(elevatezoom).length) {
              var a = $(img_zoom);
              a.elevateZoom({
                  gallery: gallery_main,
                  galleryActiveClass: "active",
                  zoomType: "inner",
                  cursor: "pointer",
                  zoomWindowFadeIn: 300,
                  zoomWindowFadeOut: 300,
                  scrollZoom: !0,
                  easing: !0,
                  loadingIcon: window.loader_gif
              }), "both" == window.main_image_display && $(img_zoom).bind("click", function(a) {
                  var b = $(img_zoom).data("elevateZoom");
                  return $.fancybox(b.getGalleryList(), {
                      closeBtn: !1,
                      helpers: {
                          buttons: {}
                      }
                  }), !1
              })
          }
        
          var img_thumb = featureProductOptions.img_thumb;
      		$(featureProductOptions.gallery_main_id).length && (roar.touch ? $(featureProductOptions.main_image).on("click", function() {
            var a = [],
                b = 0,
                c = $(img_thumb);
            return c.each(function(c, d) {
                a.push({
                    href: d.href,
                    title: d.title
                }), $(this).hasClass("active") && (b = c)
            }), $.fancybox(a, {
                closeBtn: !1,
                index: b,
                openEffect: "none",
                closeEffect: "none",
                nextEffect: "none",
                prevEffect: "none",
                helpers: {
                    buttons: {}
                }
            }), !1
        }) : "lightbox" == window.main_image_display && $(featureProductOptions.fancybox).on(roar.clickEv, function() {
            var a = [],
                b = 0,
                c = $(img_thumb);
            return c.each(function(c, d) {
                a.push({
                    href: d.href,
                    title: d.title
                }), $(this).hasClass("active") && (b = c)
            }), $.fancybox(a, {
                closeBtn: !1,
                index: b,
                helpers: {
                    buttons: {}
                }
            }), !1
        }),  $(featureProductOptions.product_image).on("click", ".image-thumb", function() {
            var a = $(this);
            if (!a.hasClass("active")) {
                var b = $(featureProductOptions.main_image_bg),
                    c = a.parents(".product-image-wrapper"),
                    d = a.attr("data-image-zoom"),
                    e = a.attr("data-image");
                b.show(), c.find(".image-thumb").removeClass("active"), a.addClass("active"), c.find(".main-image").find("img").attr("data-zoom-image", d), c.find(".main-image").find("img").attr("src", e).load(function() {
                    b.hide()
                })
            }
            return !1
        }))
      });
    },
    _pulsate: function() {
      jQuery('.pulsate-regular').pulsate({
        reach: 20,
        speed: 1000,
        pause: 1000
      });
    },
    
    onUnload: function(evt) {
      this.$container.off(this.sidebarNamespace);
    },
    onSelect: function(evt) {
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });

  return Sidebars;
})();
$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('special-offers', theme.SpecialOffers);
  sections.register('featured-products', theme.FeaturedProducts);
  sections.register('featured-collections', theme.FeaturedCollections);
  sections.register('one-product', theme.Oneproduct);
  sections.register('home-slideshow', theme.SlideShows);
  sections.register('special-products', theme.SpecialProducts);
  sections.register('sidebar', theme.Sidebars);
});
